(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lynks-shopping-guides"] && !Shopify.designMode) return;
  try {
    const lynksGuideIds = new Set(['lynks-fit-guide', 'lynks-width-title', 'lynks-video-title', 'lynks-how-home']);
function focusLynksGuide(hash) {
  const id = hash.slice(1);
  if (!lynksGuideIds.has(id)) return;
  const target = document.getElementById(id);
  if (!target) return;
  const disclosure = target.closest('details');
  if (disclosure) disclosure.open = true;
  target.focus({ preventScroll: true });
  target.scrollIntoView({ block: 'start' });
}
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-lynks-guide]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href, location.href);
  if (url.origin === location.origin && url.pathname === location.pathname) focusLynksGuide(url.hash);
});
window.addEventListener('hashchange', () => focusLynksGuide(location.hash));
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => focusLynksGuide(location.hash));
} else {
  focusLynksGuide(location.hash);
}
  } catch(e) { console.error(e); }
})();

})();
